import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { updateLanguageInHeaders } from "../../network/api";
import {
  storeApp,
  storeuserRole,
} from "../../Store/TemplateStore/template.action";

import DupontButton from "../DupontButton";
import { API_URLS } from "../../network/appUrls";
import { saveUser } from "../../network/cipAPI";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";
import DupontIconButton from "../DupontIconButton";
import WPTertiaryButton from "../../packages/WPTertiaryButton";
import { ArrowLeftIcon, ROAdvisorLogo, DuPontTMLogo } from "../../assets/icons";
import IconButton from "../../packages/IconButton";
import IconWithTooltip from "../../common/styles/components/headings/IconWithTooltip";

import "./index.scss";

const basePath = API_URLS.basePath;
const userManualUrl = process.env.REACT_APP_USER_MANUAL_URL;

const Header = (props) => {
  const accessUserPlant = useSelector((state) => state.accessUserPlant);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const userName = useSelector((state) => state.userName);
  const userRole = useSelector((state) => state.userRole);
  const userEmail = useSelector((state) => state.userEmail);
  const companyName = useSelector((state) => state.companyName);
  const country = useSelector((state) => state.country);

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  const changeLanguage = async (lng) => {
    i18n.changeLanguage(lng);
    updateLanguageInHeaders(lng);
  };

  const payload = {
    email: userEmail,
    company: companyName,
    country: country,
    role: null,
    industry: null,
  };
  const saveUserDetails = async (payload) => {
    try {
      let response = await saveUser(payload);
      const { user_role } = response;
      dispatch(storeuserRole(`${user_role}`));
    } catch (error) {
      console.error("Error saving user information:", error);
    }
  };
  const onHomeClicked = () => {
    dispatch(storeApp(null));
    saveUserDetails(payload);
    const path = `${basePath}plants`;
    navigate(path);
  };
  const handleBackToUserManagement = () => {
    dispatch(storeApp(null));
    dispatch({ type: "STORE_ACCESS_USER_PLANT", payload: false });
    navigate("/user-management");
  };

  const onMenuClicked = () => {
    dispatch(storeApp(null));
    saveUserDetails(payload);
    setMenuOpen((prev) => !prev);
  };

  const handleManageAccess = () => {
    dispatch(storeApp(null));
    setMenuOpen(false);
    navigate(`${basePath}admin-portal`);
  };

  const handleManageUser = () => {
    dispatch(storeApp(null));
    setMenuOpen(false);
    navigate(`${basePath}user-management`);
  };

  const isPathIncluded = (paths) => {
    return Array.isArray(paths)
      ? paths.some((path) => location.pathname.includes(path))
      : location.pathname.includes(paths);
  };

  return (
    <div className="header-container">
      <div className="header-left-section">
        {accessUserPlant && (
          <IconButton
            tooltip={t("addNewPlant.backUserManagement")}
            placement="bottom"
          >
            <WPTertiaryButton
              icon={<ArrowLeftIcon />}
              className="back-user-management-btn"
              onClick={handleBackToUserManagement}
            />
          </IconButton>
        )}

        <DuPontTMLogo onClick={onHomeClicked} className="header-dupont-logo" />
        <ROAdvisorLogo />
        <div className="header-title">{t("header.title")}</div>
        {/* when sign out functionality is implemented remove admin condition for icon and keep it for admin features */}
      </div>
      <div className="header-right-section">
        {userManualUrl && (
          <IconWithTooltip
            label={t("header.userManual")}
            onClick={() =>
              window.open(userManualUrl, "_blank", "noopener,noreferrer")
            }
            placement="bottom"
          />
        )}
        <span className="header-welcome">{`${t("welcomeString.welcome")}, ${userName}`}</span>
        {!isPathIncluded(["messagePage", "requestAccess"]) && (
          <>
            {userRole === "admin" && !accessUserPlant && (
              <div className="admin-menu-container" ref={menuRef}>
                <DupontIconButton>
                  <FontAwesomeIcon
                    icon={faCircleUser}
                    onClick={onMenuClicked}
                  />
                </DupontIconButton>
                {menuOpen && (
                  <div className="admin-menu-dropdown">
                    <div
                      className={`admin-menu-item ${isPathIncluded("admin-portal") ? "disabled" : ""}`}
                      onClick={handleManageAccess}
                    >
                      {t("adminPage.manageAcess")}
                    </div>
                    <div
                      className={`admin-menu-item ${isPathIncluded("user-management") ? "disabled" : ""}`}
                      onClick={handleManageUser}
                    >
                      {t("adminPage.userManagement")}
                    </div>
                  </div>
                )}
              </div>
            )}
            <DupontButton
              type="tertiary"
              customClass="lang-btn"
              onClick={() => changeLanguage("en")}
              disabled={props.activeStep && props.activeStep > 0}
            >
              en
            </DupontButton>
            <DupontButton
              type="tertiary"
              customClass="lang-btn chinese-btn"
              onClick={() => changeLanguage("zh")}
              disabled={props.activeStep && props.activeStep > 0}
            >
              中文
            </DupontButton>
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
